module.exports = __webpack_public_path__ + "img/copy1.228e722a.228e722a.png";